import { ClickAwayListener, Grow, Popper } from '@material-ui/core';
import React from 'react';
import type { UseBooleanActions } from 'react-use-boolean';
import { Paper } from '../Paper';
import { FilterButton } from './FilterButton';

export interface FilterLayoutProps {
  label: string;
  isActive: boolean;
  ariaControls: string;
  openActions: UseBooleanActions;
  open: boolean;
}

export const FilterLayout: React.FC<FilterLayoutProps> = ({
  label,
  isActive,
  ariaControls,
  openActions,
  open,
  children,
}) => {
  const anchorRef = React.useRef<HTMLButtonElement>(null);
  return (
    <>
      <FilterButton
        ariaControls={ariaControls}
        isActive={isActive}
        ref={anchorRef}
        onClick={openActions.on}
      >
        {label}
      </FilterButton>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        placement='bottom-start'
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={openActions.off}>{children}</ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};
